import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetBirthCountries = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (validityDate: string) => {
        const { data } = await send<Types.IGetBirthCountriesRequestData, Types.IGetBirthCountriesResponseData>({
            ID: 35896,
            description: 'Get Birth Countries Request',
            responses: [35897, 35898],
            casino: casinoName,
            validityDate
        });

        return data;
    }, [send, casinoName]);
};
